import { connect } from 'react-redux';
import Content from './Content';

const mapStateToProps = ({
  content: { sections }
}) => ({
  sections
});

export default connect(mapStateToProps, null)(Content);



// WEBPACK FOOTER //
// ./src/universal/components/Content/index.js